  <template>
    <v-container fluid>
      <nav class="navbar">
        <div style="display:flex">
          <div class="home__logo">
            <v-img :src="home_logo" class="logo"/>
          </div>

          <div style="width:100%;">
            <div class="login__info">
              <a id="user_name" class="user_name" v-show="this.$getters.userName" href="javascript:void(0);" @click="myInfo()">
                {{ this.$getters.userName }}님
              </a>

              <v-btn class="login_btn" outlined v-show="!$getters.isLogin" >
                로그인
              </v-btn>

              <v-btn class="login_btn" outlined v-show="$getters.isLogin" >
                로그아웃
              </v-btn>

              <v-btn class="alert_btn"> 
                알림설정 
              </v-btn>
            </div>

            <ul>
              <li class="menu">
                <v-icon color="white">mdi-menu</v-icon>
                <span class="ml-2">기본모듈</span>
              </li>

              <li class="menu">
                <v-icon color="white">mdi-calendar-blank</v-icon>
                <span class="ml-2">관리일지</span>
              </li>
              
              <li class="menu">
                <v-icon color="white">mdi-fan</v-icon>
                <span class="ml-2">환기제어</span>
              </li>

              <li class="menu">
                <v-icon color="white">mdi-blur</v-icon>
                <span class="ml-2">악취제어</span>
              </li>

              <li class="menu">
                <v-icon color="white">mdi-cloud</v-icon>
                <span class="ml-2">ESG</span>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <div class="content__container">
        <div class="farm__info background_content">
          <v-icon color="#3a4f3f" size="30" class="mr-2">mdi-home-circle</v-icon>
          <div class="content_title">성우농장</div>
        </div>

        <div class="dash__info">
          <div style="display:flex;">
            <div class="sell__info background_content">
                <div class="content__title">• 실시간 시장정보</div>

                <div class="market__content mt-3">
                  <div class="cash__info shadow">
                    <h3 class="mt-3">전국</h3>
                    <h2>6,500  <span style="font-size:15px">원/kg</span> </h2>
                    <div class="mb-3" style="color:#88191a">(▴ 200)</div>
                    <hr/>

                    <div class="market__content mt-3">
                      <div style="font-size:13px;">시작가</div>
                      <h4>6,250</h4>
                    </div>

                    <div class="market__content">
                      <div style="font-size:13px;">당일 최고가</div>
                      <h4>6,600</h4>
                    </div>

                    <div class="market__content">
                      <div style="font-size:13px;">당일 최저가</div>
                      <h4>6,250</h4>
                    </div>
                  </div> 

                  <div class="cash__chart shadow ml-2">
                    <h4 class="mb-2">실시간 가격 돼지(탕박)</h4>
                    <LineChartGenerator
                        :chart-options="options"
                        :chart-data="marketData"
                        :height="200"
                      />
                  </div>
                </div>

                <div>
                  <div class="mt-2" style="letter-spacing: -1px; font-size:12px; color:gray;">
                    <div>돼지 평균가격(등외 제외) 은 이전 경매일 대비 상승, 은 이전 경매일 대비 하락을 나타냄</div>
                    <div>※ 실시간 경매시황 중계는 도매시장과 축산물품질평가원간 경매내역 전송이 지연될 경우가 있으므로 금일의 거래현황을 참고하시는 자료로 사용하시기 바라며, 정확한 경락단가 및 두수는 기간별 경락가격을 참고하시기 바랍니다.</div>
                    <div>※ 안동봉화축협은 전국 평균 가격에서 제외함</div>
                  </div>
                </div>
              </div>
              <div class="sell__info background_content">
                <div class="content__title">• 날씨정보</div>
                <div style="text-align:center; margin-top:10px;">
                  <img :src="capture" style="margin-top:40px; max-width:650px;"/>
                </div>
              </div>
            </div>
          </div>

          <div style="display:flex;">
              <div class="sell__info background_content">
                  <div class="content__title">• 센서데이터</div>
                      <v-carousel hide-delimiters height="250" >
                        <v-carousel-item cover>
                          <h3 class="mt-2 mb-2 ml-3" style="color:#3a4f3f">모돈사</h3>
                          <div class="sensor__content">
                            
                            <!-- <div class="margin">
                              <div class="sensor__title">모돈사지하</div>
                              <div class="sensor__value">
                                <div><v-icon class="mr-3">mdi-thermometer</v-icon> 19.2 ℃</div>
                                <div><v-icon class="mr-3">mdi-water</v-icon> 92 %</div>
                              </div>
                            </div> -->

                            <div class="margin">
                              <div class="sensor__title">분만1방</div>
                              <div class="sensor__value">
                                <div><v-icon class="mr-3">mdi-thermometer</v-icon> 27.4 ℃</div>
                                <div><v-icon class="mr-3">mdi-water</v-icon> 75 %</div>
                              </div>
                            </div>

                            <div class="margin">
                              <div class="sensor__title">분만2방</div>
                              <div class="sensor__value">
                                <div><v-icon class="mr-3">mdi-thermometer</v-icon> 25.5 ℃</div>
                                <div><v-icon class="mr-3">mdi-water</v-icon> 75 %</div>
                              </div>
                            </div>

                            <div class="margin">
                              <div class="sensor__title">분만3방</div>
                              <div class="sensor__value">
                                <div><v-icon class="mr-3">mdi-thermometer</v-icon> 26.6 ℃</div>
                                <div><v-icon class="mr-3">mdi-water</v-icon> 72 %</div>
                              </div>
                            </div>

                            <div class="margin">
                              <div class="sensor__title">분만4방</div>
                              <div class="sensor__value">
                                <div><v-icon class="mr-3">mdi-thermometer</v-icon> 27.0 ℃</div>
                                <div><v-icon class="mr-3">mdi-water</v-icon> 80 %</div>
                              </div>
                            </div>

                            <div class="margin">
                              <div class="sensor__title">임신사</div>
                              <div class="sensor__value">
                                <div><v-icon class="mr-3">mdi-thermometer</v-icon> 26.5 ℃</div>
                                <div><v-icon class="mr-3">mdi-water</v-icon> 76 %</div>
                                <div><v-icon class="mr-3">mdi-weather-cloudy</v-icon> 1542 ppm</div>
                                <div><v-icon class="mr-3">mdi-waves</v-icon> 6.3 ppm</div>
                              </div>
                            </div>

                          </div>
                        </v-carousel-item>

                        <v-carousel-item cover>
                          <h3 class="mt-2 mb-2 ml-3" style="color:#3a4f3f">자돈사</h3>
                          <div class="sensor__content">
                            
                            <div class="margin">
                              <div class="sensor__title">육성1방</div>
                              <div class="sensor__value">
                                <div><v-icon class="mr-3">mdi-thermometer</v-icon> 30.8 ℃</div>
                                <div><v-icon class="mr-3">mdi-water</v-icon> 77 %</div>
                              </div>
                            </div>

                            <div class="margin">
                              <div class="sensor__title">육성2방</div>
                              <div class="sensor__value">
                                <div><v-icon class="mr-3">mdi-thermometer</v-icon> 30.8 ℃</div>
                                <div><v-icon class="mr-3">mdi-water</v-icon> 87 %</div>
                              </div>
                            </div>

                            <div class="margin">
                              <div class="sensor__title">육성3방</div>
                              <div class="sensor__value">
                                <div><v-icon class="mr-3">mdi-thermometer</v-icon> - ℃</div>
                                <div><v-icon class="mr-3">mdi-water</v-icon> - %</div>
                              </div>
                            </div>

                            <div class="margin">
                              <div class="sensor__title">육성4방</div>
                              <div class="sensor__value">
                                <div><v-icon class="mr-3">mdi-thermometer</v-icon> 31.4 ℃</div>
                                <div><v-icon class="mr-3">mdi-water</v-icon> 82 %</div>
                              </div>
                            </div>
                          </div>
                        </v-carousel-item>
                      </v-carousel>
                  </div>
              <div class="sell__info background_content">
                <div class="content__title">• 성우농장 월별 출하두수</div>
                <div class="mt-5">
                  <LineChartGenerator
                    :chart-options="Selloptions"
                    :chart-data="sellData"
                    :height="200"
                  />
                </div>
              </div>
              </div>
              
              <div class="background_content" style="width:100%;">
                <div class="content__title mb-5">• 에너지 사용 패턴</div>
                <div style="display:flex;">
                  <div class="chart_Layout shadow" style="width:50%; padding:20px;">
                    <div style="text-align:center;">
                      <h3>
                        이번달 예상 청구 금액 
                        <v-icon color="#3a4f3f">mdi-cash</v-icon> 
                        11,916,069원
                      </h3>
                      <div style="margin-left:210px; font-size:13px;">농사용(을) 고압 A</div>
                    </div>

                    <div style="font-weight:500;">전력량</div>
                    <Bar
                      :chart-options="baroption"
                      :chart-data="barData"
                      :height="200"
                    />
                  </div>

                  <div class="chart_Layout shadow ml-2" style="width:50%; padding:20px;">
                    <div style="text-align:center;">
                      <h3>
                        성우농장 온실가스 총 배출량
                        <v-icon color="#3a4f3f">mdi-menu-right</v-icon> 
                        1,250,380.802 
                        <span style="font-size:13px;">kg CO2eq</span>
                      </h3>
                    </div>

                    <div style="font-weight:500;">배출량</div>
                    <Bar
                      :chart-options="baroption"
                      :chart-data="esgData"
                      :height="200"
                    />
                  </div>
                </div>
              </div>
            </div>
    </v-container>
  </template>

  <script>
  import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
  import { Bar } from 'vue-chartjs/legacy'
  import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  BarElement,
  CategoryScale,
  PointElement,
  Filler
  } from 'chart.js'

  ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  BarElement,
  CategoryScale,
  PointElement,
  Filler,
  )
  export default {
  name: 'HomeDash',
  components: {
      LineChartGenerator,
      Bar
  },
  methods: {
  },  
  data() {
    return {
      home_logo: require("@/assets/home_logo.svg"),
      capture: require("@/assets/capture.png"),


      icon_logout: require("@/assets/home/icon_logout_white.svg"),
      icon_login: require("@/assets/home/icon_login_white.svg"),

      icon_home_white: require("@/assets/home/icon_home_white.svg"),
      logo_white: require("@/assets/images/logo_white.svg"),
      baroption: {
        responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 1000
        },
        plugins: {
          legend: {
              display: false,
          }
        },
        scales: {
            x: {
              grid: {
                        display: false
                    },
              ticks: {
                  // 보이는 갯수 제한하기 autoSkip, maxTrickLimit 
                  autoSkip: true,
                  maxTicksLimit:5,
                  maxRotation: 0,
                  minRotation: 0,
                  display: true,
                  padding: 3,
                  font: {
                      size: 15,
                  }
              }
          },
        },
        interaction: {
              mode: 'nearest',
              axis: 'x',
              intersect: false
              },
      },
      options:{
        responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 1000
        },
        plugins: {
          legend: {
              display: false,
          }
        },
        scales: {
            x: {
              grid: {
                        display: false
                    },
              ticks: {
                  // 보이는 갯수 제한하기 autoSkip, maxTrickLimit 
                  autoSkip: true,
                  maxTicksLimit:5,
                  maxRotation: 0,
                  minRotation: 0,
                  display: true,
                  padding: 3,
                  font: {
                      size: 15,
                  }
              }
          },
      },
      interaction: {
              mode: 'nearest',
              axis: 'x',
              intersect: false
              },
          elements: {
              line: {	/* 선 옵션 */
                  borderCapStyle: 'round',
                  borderDashOffset: 0,
                  borderJoinStyle: 'round',	
                  borderWidth: 2.5,
                  capBezierPoints: true,
                  // fill: true,
                  tension: 0.4
              },
              point: {	/* 표시자 옵션 */
                  pointStyle: 'rectRounded',
                  pointRadius: 0, 
                  lineTension:1, 
                  pointBorderWidth: 0, 
              },
          },
        },

      Selloptions:{
        responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 1000
        },
        plugins: {
          legend: {
              display: true,
              position: "top",
              labels: {
                  boxWidth: 1,
                  padding: 5,
                  pointStyle: "circle",
                  font: {
                      size: 13
                  }
              },
              fullSize: true,
              align: "left"
          }
        },
        scales: {
            x: {
              grid: {
                        display: false
                    },
              ticks: {
                  maxRotation: 0,
                  minRotation: 0,
                  display: true,
                  padding: 3,
                  font: {
                      size: 15,
                  }
              }
          },
      },
      interaction: {
              mode: 'nearest',
              axis: 'x',
              intersect: false
              },
          elements: {
              line: {	/* 선 옵션 */
                  borderCapStyle: 'round',
                  borderDashOffset: 0,
                  borderJoinStyle: 'round',	
                  borderWidth: 2.5,
                  capBezierPoints: true,
                  // fill: true,
                  tension: 0
              },
              point: {	/* 표시자 옵션 */
                  pointStyle: 'rectRounded',
                  pointRadius: 0, 
                  lineTension:1, 
                  pointBorderWidth: 0, 
              },
          },
        },

        marketData: {
          labels: ['07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00',],
          datasets: [
          {
                label:'온도',
                data: [6250,6300,6400,6450,6350,6600,6500,],
                yAxisID: 'y-axis-1',
                borderColor: '#00B9C1',
            },
          ],
        },

        sellData: {
          labels: ['1월','2월','3월','4월','5월','6월'],
          datasets: [
          {
                label:'1+',
                data: [33,30,33,40,30,36],
                borderColor: '#8CC0DE',
            },
            {
                label:'1',
                data: [33,35,42,40,30,36],
                borderColor: '#CCEEBC',
            },
            {
                label:'2',
                data: [36,33,38,40,30,36],
                borderColor: '#FFD6A5',
            },
            {
                label:'등외',
                data: [22,35,27,40,30,36],
                borderColor: '#FFF9D0',
            },
          ],
        },

        chartData: {
          labels: ['24-6-18 1:00','24-6-18 2:00', '24-6-18 3:00','24-6-18 4:00','24-6-18 5:00','24-6-18 6:00'],
          datasets: [
          {
                label:'온도',
                data: [29.2,29.5,29.6,28.4,27.7,27.7],
                yAxisID: 'y-axis-1',
                borderColor: '#00B9C1',
            },
            {
                label:'암모니아',
                data: [3.4,3.7,4.2,5.0,4.8,5.0],
                yAxisID: 'y-axis-2',
                borderColor: '#EEE8A9',
            },
          ],
        },
        barData:{
          labels: ['24-7-5 1:00','24-7-5 2:00', '24-7-5 3:00','24-7-5 4:00','24-7-5 5:00','24-7-5 6:00','24-7-5 7:00','24-7-5 8:00', '24-7-5 9:00','24-7-5 10:00','24-7-5 11:00','24-7-5 12:00','24-7-5 13:00','24-7-5 14:00', '24-7-5 15:00','24-7-5 16:00'],
          datasets: [
          {
                label:'전력량',
                data: [151.69, 205.77, 220.56, 235.78, 211.18, 91.46, 151.69, 205.77, 220.56, 235.78, 211.18, 91.46,151.69,  ],
                barPercentage: 0.99,
                borderRadius: 8,
                borderWidth: 1 
            }
          ],
        },
        esgData:{
          labels: ['장내발효','분뇨처리','에너지'],
          datasets: [
          {
                label:'배출량',
                data: [90899.802 , 412901 , 746580],              
                barPercentage: 0.3,
                borderRadius: 8,
                backgroundColor: ['rgba(26, 33, 48, 0.6)','rgba(90, 114, 160, 0.6)', 'rgba(131, 180, 255, 0.6)',  ],
            }
          ],
        }
    }
  },

  }
  </script>

  <style scoped lang="scss">
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .v-application--wrap .v-main{
    padding: 0px 0px 0px !important;
  }
  .navbar{
    background-color:#d2ded5;
    width:100%;
  }
  .login__info{
    display:flex;
    margin-top:10px;
    justify-content: flex-end;
    margin-right:30px;
  }
  .user_name{
    margin-top:-15px;
    margin-right:10px;
  }
  .login_btn{
    background-color:transparent !important;
    border:1px solid white;
    border-radius: 30px;
    margin-right:5px;
  }
  ul{
    text-align: center;
  }
  li{
      display: inline-block;
      text-align: center;
      // width: 19%;
  }
  li > a{
      text-decoration: none;
      color: white;
  }
  li:hover{
      background-color: #3a4f3f;
      color:white;
      transition: 1s;
  }
  .alert_btn{
    background-image: linear-gradient(to bottom, #fcfcfc, #cfcfcf);
    border-radius: 30px;
  }
  .nav__container{
    padding:10px;
  }
  .home__logo{
    padding:30px;
    // width:20%;
  }
  .logo{
    width:200px;
    height:50px;
  }
  .menu{
    width:200px;
    max-width:180px;
    padding:15px;
    margin-right:50px;
    text-align:center;
    font-size:18px;
    font-weight:600;
    color:#3a4f3f;
  }
  .content__container{
    background-color:#fafafa;
    padding:20px 30px 10px 20px;
  }
  .icon_circle{
    background-color:#3a4f3f;
    padding:5px;
    margin-right:10px;
    border-radius: 50%;
  }
  .content_title{
    font-size:23px;
    font-weight:600;
  }
  .farm__info{
    width:25%;
    display:flex;
    justify-content: center;
    padding:10px !important;
    margin-top:-10px !important;
  }
  .background_content{
    margin:5px;
    background-color:white;
    box-shadow:0 1px 4px rgb(0, 0, 0, .2);
    border-radius: 5px;
    padding:20px;
  }

  .sell__info{
    min-width:50%;
  }
  .content__title{
    font-size:20px;
    font-weight:600;
    text-align:start;
  }
  .dash__info{
    width:100%;
  }
  .market__content{
    display:flex;
    justify-content: space-between;
  }
  .shadow{
    box-shadow: rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px;
    padding:20px;
  }
  .cash__info{
    width:25%;
  }
  .cash__chart{
    width:75%;
  }
  .sensor__content{
    display:flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  .margin{
    margin-top:10px;
    margin-right:10px;
  }
  .sensor__title{
    padding:10px;
    text-align:center;
    color:white;
    font-weight:700;
    background-image: linear-gradient(60deg, #9ce2df 0%, #59ccc6 100%);
    border-radius: 10px 10px 0 0;
    // width:50px;
    min-width:50px;
  }
  .sensor__value{
    background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);
    padding:10px;
    border-radius: 0 0 10px 10px;
    height:100px;
    display:flex;
    flex-direction: column;
    justify-content: center;
    font-size:13px;
  }
  </style>
